<template>
  <survey :survey="survey"/>
</template>
<script>
import * as Survey from 'survey-vue';
import 'survey-vue/survey.css';
import axios from 'axios';
// import '../../../dist/css/evaluation.css';
import _ from 'lodash';

Survey.surveyLocalization.locales[Survey.surveyLocalization.defaultLocale].requiredError = '请回答';
Survey.surveyLocalization.locales[Survey.surveyLocalization.defaultLocale].completeText = '完成';
Survey.StylesManager.ThemeColors['default']['$background-dim'] = '#f3f3f3';
Survey.StylesManager.ThemeColors['default']['$body-background-color'] = 'white';
Survey.StylesManager.ThemeColors['default']['$body-container-background-color'] = '#f4f4f4';
Survey.StylesManager.ThemeColors['default']['$border-color'] = '#e7e7e7';
Survey.StylesManager.ThemeColors['default']['$disable-color'] = '#dbdbdb';
Survey.StylesManager.ThemeColors['default']['$disabled-label-color'] = 'rgba(64, 64, 64, 0.5)';
Survey.StylesManager.ThemeColors['default']['$disabled-slider-color'] = '#cfcfcf';
Survey.StylesManager.ThemeColors['default']['$disabled-switch-color'] = '#9f9f9f';
Survey.StylesManager.ThemeColors['default']['$error-background-color'] = '#fd6575';
Survey.StylesManager.ThemeColors['default']['$error-color'] = '#ed5565';
Survey.StylesManager.ThemeColors['default']['$foreground-disabled'] = '#161616';
Survey.StylesManager.ThemeColors['default']['$foreground-light'] = '#909090';
Survey.StylesManager.ThemeColors['default']['$header-background-color'] = '#e7e7e7';
Survey.StylesManager.ThemeColors['default']['$header-color'] = '#6d7072';
Survey.StylesManager.ThemeColors['default']['$inputs-background-color'] = 'white';
Survey.StylesManager.ThemeColors['default']['$main-color'] = '#042859';
Survey.StylesManager.ThemeColors['default']['$main-hover-color'] = '#021228';
Survey.StylesManager.ThemeColors['default']['$progress-text-color'] = '#9d9d9d';
Survey.StylesManager.ThemeColors['default']['$slider-color'] = 'white';
Survey.StylesManager.ThemeColors['default']['$text-color'] = '#6d7072';
Survey.StylesManager.ThemeColors['default']['$text-input-color'] = '#6d7072';
Survey.StylesManager.applyTheme('default');

export default {
  name: 'surveyjs-component',
  data () {
    const json = {
      showQuestionNumbers: 'off',
      showCompletedPage: true,
      completedHtml: window.evaluation_script_data.evaluation_response_1,
      questions: [
        {
          type: 'radiogroup',
          isRequired: true,
          name: 'Q1',
          title: '1. 您在?',
          choices: [
            '新西兰境内',
            '新西兰境外',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境内'",
          type: 'radiogroup',
          isRequired: true,
          name: 'Q2A',
          title: '2. 您想办理?',
          choices: [
            '新西兰留学及签证',
            '澳洲留学及签证',
            '新西兰旅游签证',
            '新西兰工作签证',
            '新西兰技术移民',
            '新西兰投资移民',
            '新西兰父母退休移民',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外'",
          type: 'radiogroup',
          isRequired: true,
          name: 'Q2B',
          title: '2. 您想办理?',
          choices: [
            '新西兰留学及签证',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境内' and {Q2A}='新西兰留学及签证'",
          type: 'panel',
          name: 'Q3',
          elements: [
            {
              type: 'radiogroup',
              isRequired: true,
              name: 'Q3_1',
              title: '3. 您现在持有的签证是?',
              choices: [
                '学生签证',
                '旅游签证',
                '工作签证',
              ],
            },
            {
              type: 'text',
              inputType: 'date',
              isRequired: true,
              name: 'Q3_2',
              title: '您签证的到期日期为?',
            },
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境内' and {Q2A}='新西兰留学及签证' and {Q3_1}='学生签证'",
          type: 'panel',
          name: 'Q4',
          elements: [
            {
              type: 'text',
              isRequired: true,
              name: 'Q4_1',
              title: '4. 您目前学习的课程是?',
            },
            {
              type: 'radiogroup',
              isRequired: true,
              name: 'Q4_2',
              title: '您是否已经完成目前的课程?',
              choices: [
                '是',
                '否',
              ],
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q4_3',
              title: '您目前的出勤率?',
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q4_4',
              title: '您目前的成绩?',
            },
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境内' and {Q2A}='新西兰留学及签证' and ({Q3_1}='学生签证' or {Q3_1}='旅游签证' or {Q3_1}='工作签证')",
          type: 'radiogroup',
          isRequired: true,
          name: 'Q5',
          title: '5. 您的学习计划是?',
          choices: [
            '续读本校',
            '已经有新的学校和新的offer',
            '需要帮助申请新offer',
            '需要咨询学习计划',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境内' and {Q2A}='新西兰留学及签证' and ({Q3_1}='学生签证' or {Q3_1}='旅游签证' or {Q3_1}='工作签证')",
          type: 'checkbox',
          isRequired: true,
          name: 'Q6',
          title: '6. 您是否有以下签证问题? (可多选)',
          choices: [
            '严重缺勤（出勤率低于75%）',
            '严重挂科（挂科超过50%）',
            '银行账单有大额进账（超过$1000）',
            '有被学校劝退历史',
            '有逾期滞留历史',
            '有签证拒签历史',
            '有非法打工或超时打工',
            '体检问题（如肺结核、乙肝、糖尿病等）',
            '品行问题（如酒驾、上庭、隐瞒、提供虚假材料等）',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境内' and {Q2A}='新西兰留学及签证' and ({Q3_1}='学生签证' or {Q3_1}='旅游签证' or {Q3_1}='工作签证')",
          type: 'panel',
          name: 'Q7',
          elements: [
            {
              type: 'text',
              isRequired: true,
              name: 'Q7_1',
              title: '7. 姓名?',
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q7_2',
              title: '电话?',
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q7_3',
              title: '微信?',
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q7_4',
              title: '护照号码?',
            },
            {
              type: 'text',
              inputType: 'date',
              isRequired: true,
              name: 'Q7_5',
              title: '生日?',
            },
            {
              type: 'html',
              name: 'Q7_6',
              html: '<div><strong>条款声明</strong></div><ul><li>* 条款声明A</li><li>* 条款声明B</li><li>* 条款声明C</li></ul>',
            },
            {
              type: 'checkbox',
              isRequired: true,
              name: 'Q7_7',
              title: '您是否同意?',
              choices: [
                '我同意以上条款并授权蓬景国际代表我向移民局索要相关信息',
              ],
            },
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'radiogroup',
          isRequired: true,
          name: 'Q8',
          title: '8. 您是否来过新西兰?',
          choices: [
            '是',
            '否',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'checkbox',
          isRequired: true,
          name: 'Q9',
          title: '9. 您目前的情况是? (可多选)',
          choices: [
            '小学/初中在读',
            '初中毕业',
            '高中在读',
            '高中毕业',
            '大学在读',
            '大学毕业',
            '研究生毕业',
            '研究生在读',
            '在职',
            '离职',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'radiogroup',
          isRequired: true,
          name: 'Q10',
          title: '10. 您的父母是否来新西兰陪读? (18岁以下父母一方可陪读)',
          choices: [
            '是',
            '否',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'checkbox',
          isRequired: true,
          name: 'Q11',
          title: '11. 您赴新西兰的留学的目的是? (可多选)',
          choices: [
            '读语言',
            '读初/高中',
            '读大学',
            '读研究生',
            '陪家人',
            '最终为了移民',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'checkbox',
          isRequired: true,
          name: 'Q12',
          title: '12. 您是否办理过新西兰留学? (可多选)',
          choices: [
            '咨询过中介',
            '申请过学校',
            '申请过签证',
            '都没有申请过',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'checkbox',
          isRequired: true,
          name: 'Q13',
          title: '13. 您需要我们帮您办理? (可多选)',
          choices: [
            '咨询留学和学习计划',
            '申请学校',
            '申请签证',
            '接机',
            '陪同办理入学',
            '寻找住宿家庭',
            '购买学生保险',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'radiogroup',
          isRequired: true,
          name: 'Q14',
          title: '14. 您的英语基础是?',
          choices: [
            '零基础',
            '初中水平',
            '高中水平',
            '大学四级',
            '大学六级',
            '雅思5分',
            '雅思6分以上',
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'panel',
          name: 'Q15',
          elements: [
            {
              type: 'radiogroup',
              isRequired: true,
              name: 'Q15_1',
              title: '15. 您赴新西兰留学的费用来源?',
              choices: [
                '本人工资收入',
                '父母工资收入',
                '股票、不动产变卖',
                '由新西兰朋友、家人担保',
              ],
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q15_2',
              title: '您或父母的工资年收入? (万人民币)',
            },
            {
              type: 'radiogroup',
              isRequired: true,
              name: 'Q15_3',
              title: '您或父母是否能够提供有继续经济能力的相关证明?',
              choices: [
                '6个月以上定存30-50万人民币',
                '房产',
                '6个月以上自营企业流水',
                '6个月以上股票交易记录',
              ],
            },
          ],
        },
        {
          visibleIf: "{Q1}='新西兰境外' and {Q2B}='新西兰留学及签证'",
          type: 'panel',
          name: 'Q16',
          elements: [
            {
              type: 'text',
              isRequired: true,
              name: 'Q16_1',
              title: '16. 姓名?',
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q16_2',
              title: '电话?',
            },
            {
              type: 'text',
              isRequired: true,
              name: 'Q16_3',
              title: '微信?',
            },
            {
              type: 'html',
              name: 'Q16_4',
              html: '<div><strong>条款声明</strong></div><ul><li>* 条款声明A</li><li>* 条款声明B</li><li>* 条款声明C</li></ul>',
            },
            {
              type: 'checkbox',
              isRequired: true,
              name: 'Q16_5',
              title: '您是否同意?',
              choices: [
                '我同意以上条款并授权蓬景国际代表我向移民局索要相关信息',
              ],
            },
          ],
        },
      ],
    };

    const survey = new Survey.Model(json);

    survey.onComplete.add(async sender => {
      await this.$recaptchaLoaded();
      this.recaptcha_token = await this.$recaptcha('submit_evaluation_form');

      let formData = new FormData();
      formData.append('wp_nonce', this.wp_nonce);
      formData.append('action', this.wp_action);
      formData.append('recaptcha_token', this.recaptcha_token);
      formData.append('evaluation', JSON.stringify(sender.data));

      axios({
        method: 'POST',
        url: this.wp_ajax,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      });
    });

    return {
      survey: survey,
      wp_ajax: window.evaluation_script_data.wp_ajax,
      wp_nonce: window.evaluation_script_data.wp_nonce,
      wp_action: 'submit_evaluation_form',
      recaptcha_token: '',
    };
  }
};
</script>
<style scoped>
</style>
